import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { WpTokenService } from './wp-token.service';

@Injectable()
export class VerifyWpTokenGuard  {

  constructor(
    private router: Router,
    private verifyWpTokenService: WpTokenService
  ) { }

  canActivate(): boolean {

    if (this.verifyWpTokenService.isTokenExpired()) {
      this.router.navigateByUrl('/');
      return false;
    }

    return true;
  }
}
